import Vue from 'vue';
import store from './../../store';
import organizationMemberProductBusinesshourTransformer from './../../transformers/organizationMemberProductBusinessHour';

const success = ({ data }, resolve) => {
  const businesshours = organizationMemberProductBusinesshourTransformer.fetchCollection(data);
  store.dispatch('fetchAllOrganizationMemberProductBusinessHours', businesshours);
  resolve(businesshours);
};

const failed = () => {
};


export default () => (
  new Promise((resolve, reject) => {
    Vue.$http.get('/organization_member_product_businesshours')
    .then((response) => {
      success(response, resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/organizationMemberProductBusinesshour/all.js